"use client";

import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { getEnv } from "@/env";

interface RecaptchaProviderProps {
  children: React.ReactNode;
}

/**
 * reCAPTCHA v3 Provider Component
 *
 * Wraps the application with Google reCAPTCHA v3 functionality.
 * Provides reCAPTCHA context to all child components.
 */
export function RecaptchaProvider({ children }: RecaptchaProviderProps) {
  const recaptchaSiteKey = getEnv("NEXT_PUBLIC_RECAPTCHA_SITE_KEY");

  // If no site key is configured, render children without reCAPTCHA
  if (!recaptchaSiteKey) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        "reCAPTCHA site key not configured. reCAPTCHA functionality will be disabled.",
      );
    }
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: true,
        defer: true,
      }}
      container={{
        parameters: {
          badge: "bottomleft",
          theme: "light",
        },
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
